var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResidential = function SvgResidential(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 21.707C19.8946 21.5195 20 21.2651 20 20.9999V11.9999H23L12.673 2.61192C12.4889 2.4444 12.2489 2.35156 12 2.35156C11.7511 2.35156 11.5111 2.4444 11.327 2.61192L1 11.9999H4V20.9999C4 21.2651 4.10536 21.5195 4.29289 21.707C4.48043 21.8946 4.73478 21.9999 5 21.9999H19C19.2652 21.9999 19.5196 21.8946 19.7071 21.707ZM12.0004 20L14.546 17.3639C15.0495 16.8425 15.3923 16.1783 15.5312 15.4551C15.6701 14.732 15.5988 13.9824 15.3263 13.3013C15.0539 12.6201 14.5924 12.0379 14.0004 11.6283C13.4084 11.2186 12.7124 11 12.0004 11C11.2884 11 10.5924 11.2186 10.0004 11.6283C9.40835 12.0379 8.94692 12.6201 8.67444 13.3013C8.40196 13.9824 8.33066 14.732 8.46955 15.4551C8.60844 16.1783 8.95129 16.8425 9.45474 17.3639L12.0004 20Z",
    fill: "#3ACA73"
  })));
};
export default SvgResidential;